import {GET_QUESTIONS_LIST,GET_QUESTIONS_LIST_SUCCESS,GET_QUESTIONS_LIST_FAILED,GET_WORKFLOW_LIST,GET_WORKFLOW_LIST_SUCCESS,GET_WORKFLOW_LIST_FAILED, ADD_NEW_QUESTION, ADD_NEW_QUESTION_SUCCESS, ADD_NEW_QUESTION_FAILED, GET_QUESTION_DETAILS, GET_QUESTION_DETAILS_SUCCESS, GET_QUESTION_DETAILS_FAILED,UPDATE_QUESTION_DETAILS,UPDATE_QUESTION_DETAILS_SUCCESS,UPDATE_QUESTION_DETAILS_FAILED, TOGGLE_QUESTION, TOGGLE_QUESTION_SUCCESS, TOGGLE_QUESTION_FAILED,GET_WORKFLOW_OPTIONS_LIST,GET_WORKFLOW_OPTIONS_LIST_SUCCESS,GET_WORKFLOW_OPTIONS_LIST_FAILED, ADD_NEW_WORKFLOW, ADD_NEW_WORKFLOW_SUCCESS, ADD_NEW_WORKFLOW_FAILED, UPDATE_WORKFLOW_DETAILS, UPDATE_WORKFLOW_DETAILS_SUCCESS, UPDATE_WORKFLOW_DETAILS_FAILED, GET_SAMPLE_CSV_QUESTION, GET_SAMPLE_CSV_QUESTION_SUCCESS, GET_SAMPLE_CSV_QUESTION_FAILED, GET_CSV_QUESTION_STATUS,GET_CSV_QUESTION_STATUS_SUCCESS,GET_CSV_QUESTION_STATUS_FAILED, BULK_IMPORT_QUESTIONS, BULK_IMPORT_QUESTIONS_SUCCESS, BULK_IMPORT_QUESTIONS_FAILED, DELETE_WORKFLOW, DELETE_WORKFLOW_SUCCESS, DELETE_WORKFLOW_FAILED
  } from "./actionTypes"
  
  const initialState = {
    loading:false,
    questionsList:null,
    questionsListError:null,
    workFlowlist:null,
    workFlowlistError:null,
    addQuestionSuccess:null,
    addQuestionFailed:null,
    questionDetails:null,
    updateQuestionSuccess:null,updateQuestionFailed:null,
    toggleSuccess:null,toggleFailed:null,
    workFlowOptions:null,
    addWorkFlowSuccess:null,addWorkFlowFailed:null,
    updateWorkFlowSuccess:null,updateWorkFlowFailed:null,
    questionsStatus:null,
    importQuestions:null,
    deleteSuccess:null,deleteFailed:null


  }
  
  const questionsReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_QUESTIONS_LIST:
        state = { ...state ,loading:true,questionsList:null}
        break
        case GET_QUESTIONS_LIST_SUCCESS:
          state = { ...state ,loading: false,questionsList:action.payload,questionsListError:null}
          break
          
          case GET_QUESTIONS_LIST_FAILED:
            state = { ...state ,loading:false,questionsList:null,questionsListError:action.payload}
            break
            case GET_WORKFLOW_LIST:
              state = { ...state ,loading:true, workFlowlist:null,
                workFlowlistError:null,}
              break
              case GET_WORKFLOW_LIST_SUCCESS:
                state = { ...state ,loading: false ,workFlowlist:action.payload,
                  workFlowlistError:null,}
                break
                
                case GET_WORKFLOW_LIST_FAILED:
                  state = { ...state ,loading:false, workFlowlist:null,
                    workFlowlistError:action.payload,}
                  break 
                  case ADD_NEW_QUESTION:
                  state = { ...state ,loading:true, addQuestionSuccess:null,addQuestionFailed:null}
                  break 
                  case ADD_NEW_QUESTION_SUCCESS:
                  state = { ...state ,loading:false, addQuestionSuccess:action.payload,addQuestionFailed:null}
                  break 
                  case ADD_NEW_QUESTION_FAILED:
                  state = { ...state ,loading:false, addQuestionSuccess:null,addQuestionFailed:action.payload}
                  break  
                  case GET_QUESTION_DETAILS:
                    state = { ...state ,loading:true, questionDetails:null,}
                    break 
                    case GET_QUESTION_DETAILS_SUCCESS:
                    state = { ...state ,loading:false, questionDetails:action.payload,}
                    break
                    case GET_QUESTION_DETAILS_FAILED:
                      state = { ...state ,loading:false, questionDetails:null,}
                      break 
                      case UPDATE_QUESTION_DETAILS:
                        state = { ...state ,loading:true, updateQuestionSuccess:null,updateQuestionFailed:null}
                        break 
                        case UPDATE_QUESTION_DETAILS_SUCCESS:
                        state = { ...state ,loading:false, updateQuestionSuccess:action.payload,updateQuestionFailed:null}
                        break
                        case UPDATE_QUESTION_DETAILS_FAILED:
                          state = { ...state ,loading:false, updateQuestionFailed:action.payload,updateQuestionSuccess:null}
                          break 
                          case TOGGLE_QUESTION:
                        state = { ...state ,loading:true, toggleSuccess:null,toggleFailed:null}
                        break 
                        case TOGGLE_QUESTION_SUCCESS:
                        state = { ...state ,loading:false, toggleSuccess:action.payload,toggleFailed:null}
                        break
                        case TOGGLE_QUESTION_FAILED:
                          state = { ...state ,loading:false, toggleSuccess:null,toggleFailed:action.payload}
                          break 
                          case GET_WORKFLOW_OPTIONS_LIST:
                            state = { ...state ,loading:true, workFlowOptions:null}
                            break 
                            case GET_WORKFLOW_OPTIONS_LIST_SUCCESS:
                            state = { ...state ,loading:false, workFlowOptions:action.payload,}
                            break
                            case GET_WORKFLOW_OPTIONS_LIST_FAILED:
                              state = { ...state ,loading:false, workFlowOptions:null}
                              break   
                              case ADD_NEW_WORKFLOW:
                                state = { ...state ,loading:true, addWorkFlowSuccess:null,addWorkFlowFailed:null}
                                break    
                                case ADD_NEW_WORKFLOW_SUCCESS:
                                  state = { ...state ,loading:false, addWorkFlowSuccess:action.payload,addWorkFlowFailed:null}
                                  break 
                                  case ADD_NEW_WORKFLOW_FAILED:
                                    state = { ...state ,loading:false, addWorkFlowSuccess:null,addWorkFlowFailed:action.payload}
                                    break  
                                    case UPDATE_WORKFLOW_DETAILS:
                                      state = { ...state ,loading:true, updateWorkFlowSuccess:null,updateWorkFlowFailed:null}
                                      break 
                                      case UPDATE_WORKFLOW_DETAILS_SUCCESS:
                                      state = { ...state ,loading:false, updateWorkFlowSuccess:action.payload,updateWorkFlowFailed:null}
                                      break 
                                      case UPDATE_WORKFLOW_DETAILS_FAILED:
                                      state = { ...state ,loading:false, updateWorkFlowSuccess:null,updateWorkFlowFailed:action.payload}
                                      break 
                                      
                                      case GET_SAMPLE_CSV_QUESTION:
                                        state = { ...state ,loading:true, csvData:null}
                                        break 
                                        case GET_SAMPLE_CSV_QUESTION_SUCCESS:
                                        state = { ...state ,loading:false, csvData:action.payload}
                                        break 
                                        case GET_SAMPLE_CSV_QUESTION_FAILED:
                                        state = { ...state ,loading:false, csvData:null,}
                                        break  
                                        case GET_CSV_QUESTION_STATUS:
                                          state = { ...state ,loading:false, questionsStatus:null}
                                          break 
                                          case GET_CSV_QUESTION_STATUS_SUCCESS:
                                          state = { ...state ,loading:false,questionsStatus:action.payload}
                                          break 
                                          case GET_CSV_QUESTION_STATUS_FAILED:
                                          state = { ...state ,loading:false, questionsStatus:null,}
                                          break 
                                          case BULK_IMPORT_QUESTIONS:
                                            state = { ...state ,loading:true, importQuestions:null}
                                            break 
                                            case BULK_IMPORT_QUESTIONS_SUCCESS:
                                            state = { ...state ,loading:false,importQuestions:action.payload}
                                            break 
                                            case BULK_IMPORT_QUESTIONS_FAILED:
                                            state = { ...state ,loading:false, importQuestions:null,}
                                            break 
                                            case DELETE_WORKFLOW:
                                            state = { ...state ,loading:true, deleteSuccess:null,deleteFailed:null}
                                            break 
                                            case DELETE_WORKFLOW_SUCCESS:
                                            state = { ...state ,loading:false,deleteSuccess:action.payload,deleteFailed:null}
                                            break 
                                            case DELETE_WORKFLOW_FAILED:
                                            state = { ...state ,loading:false, deleteSuccess:null,deleteFailed:action.payload}
                                            break                    
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default questionsReducer
  